import React from 'react';
import "./footer.scss";
import { Link } from 'react-router-dom';
import bg from "../../assets/footer-bg.jpg";
import logo from "../../assets/logo.png";

const Footer = () => {
  return (
    <div className='footer' style={{ backgroundImage: `url(${bg})` }}>
      <div className="footer__content">
        <div className="footer__content__logo">
          <div className="logo">
            <img src={logo} alt="" />
            <Link to={`/`}>HL OTT</Link>
          </div>
        </div>

        <div className="footer__content__menus">
          <div className="footer__content__menu">
            <Link to="/">Home</Link>
            <Link to="/">Contact us</Link>
            <Link to="/">Terms of Services</Link>
            <Link to="/">About Us</Link>
          </div>

          <div className="footer__content__menu">
            <Link to="/">Live</Link>
            <Link to="/">FAQ</Link>
            <Link to="/">Premium</Link>
            <Link to="/">Privacy Poclicy</Link>
          </div>


          <div className="footer__content__menu">
            <Link to="/">You must watch</Link>
            <Link to="/">Recent release</Link>
            <Link to="/">Top IMDB</Link>
          </div>
        </div>
      </div>

      <div className="footer__me">
        <Link to="https://www.linkedin.com/in/deeptiranjan-swain-463357221/"><h1>Deeptiranjan Swain</h1></Link>
        <p>All Rights Reserved &copy; 2023</p>
      </div>
    </div>
  )
}

export default Footer
